import React from 'react';

class RedirectComponent extends React.Component {
    render() {
        return (
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <div>Thanks for visiting <a href="https://gohire.com">GoHire.com</a></div>
                <div>
                    We have upgraded our security and servers,
                    and moved the login to this page: <a href="https://app.gohire.com/login">app.gohire.com/login</a>
                </div>
                <div>Please login using the new server via the link above.</div>
            </div>
        )
    }
}

export default RedirectComponent;